
import { TeamRecord } from '@/types/teamTypes';
import { CalculateStatsProps } from '../types/tableTypes';

export const createInitialRecord = (team: string): TeamRecord => ({
  team,
  played: 0,
  wins: 0,
  draws: 0,
  losses: 0,
  goalsFor: 0,
  goalsAgainst: 0,
  goalDifference: 0,
  points: 0,
  ppg: 0,
});

export const updateTeamStats = ({
  team,
  homeGoals,
  awayGoals,
  result,
  isHome,
  record
}: CalculateStatsProps): TeamRecord => {
  record.played++;
  
  if (isHome) {
    record.goalsFor += homeGoals;
    record.goalsAgainst += awayGoals;
    
    if (result === 'H') {
      record.wins++;
      record.points += 3;
    } else if (result === 'A') {
      record.losses++;
    } else if (result === 'D') {
      record.draws++;
      record.points += 1;
    }
  } else {
    record.goalsFor += awayGoals;
    record.goalsAgainst += homeGoals;
    
    if (result === 'A') {
      record.wins++;
      record.points += 3;
    } else if (result === 'H') {
      record.losses++;
    } else if (result === 'D') {
      record.draws++;
      record.points += 1;
    }
  }

  record.goalDifference = record.goalsFor - record.goalsAgainst;
  record.ppg = record.points / record.played;

  return record;
};
